import Profile from '../components/profile';
import AboutMe from '../components/aboutMe/aboutMe';
import Blogs from '../components/blog/featured/featuredBlogs';

const index = () => (

    <div>
        <section className="section-profile">
            <Profile />
        </section>

        <section className="section-about-me">
            <AboutMe />
        </section>

        <section className="section-featured-blog">
            <Blogs />
        </section>
        
    </div>
    
);

export default index;